import { render } from "./IconToggle.vue?vue&type=template&id=03615e30"
import script from "./IconToggle.vue?vue&type=script&lang=js"
export * from "./IconToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__